import React from "react";
import { FiStar } from "react-icons/fi";

export const SupplierDetailEmptyState: React.FC = () => {
	return (
		<div
			className="flex flex-col items-center justify-center rounded-lg bg-white p-12 text-center"
			data-testid="supplier-detail-empty-state"
		>
			<FiStar className="mb-4 h-12 w-12 text-gray-300" />
			<h3 className="text-lg font-medium text-gray-900">
				No ratings yet
			</h3>
			<p className="mt-2 max-w-sm text-sm text-gray-500">
				This supplier has not been rated yet. Create a performance rating
				to start tracking their performance.
			</p>
		</div>
	);
};
